import { Button } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { ReactElement } from "react";

type ConditionValueProps = {
  value: ReactElement | string;
  onClick: () => void;
  isReadonly: boolean;
};

export const ConditionTagValue = ({
  value,
  onClick,
  isReadonly,
}: ConditionValueProps) => {
  return (
    <Button
      variant="outlined-contained"
      color="primary"
      endIcon={
        !isReadonly && <AddIcon fontSize="small" sx={{ rotate: "45deg" }} />
      }
      sx={{
        flexShrink: 0,
        textTransform: "none",
        wordBreak: "break-all",
        maxWidth: "100%",
      }}
      onClick={onClick}
    >
      {value}
    </Button>
  );
};
